"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Select = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Select"));
var _CountryFlag = _interopRequireDefault(require("@kiwicom/orbit-components/lib/CountryFlag"));
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const sortAlphabetically = arr => arr.sort((a, b) => a.name.localeCompare(b.name));
const LanguageSelect = ({
  languageId,
  setLanguage,
  brandLanguage
}) => {
  const languages = Object.values(brandLanguage.languages);
  const sortedLanguages = sortAlphabetically(languages);
  const languageOptions = sortedLanguages.map(language => ({
    value: language.id,
    label: language.name
  }));
  const languageCountry = brandLanguage.languages[languageId].flag;
  const onSetLanguage = e => {
    const {
      value
    } = e.target;
    setLanguage(value);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
    dataTest: "LanguageSelect",
    prefix: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CountryFlag.default, {
      code: languageCountry
    }),
    label: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
      id: "account.regional_settings_modal.section.language"
    })),
    options: languageOptions,
    value: languageId,
    onChange: onSetLanguage
  });
};
var _default = LanguageSelect;
exports.default = _default;